import {List, Stack, styled} from "@mui/material";
import {FlexSpaceBetween} from "@/styles/layout/boxes";

export const MobileMenuBody = styled(List)`
  width: 90%;
  margin: 5vh auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  
  a {
    text-decoration: none;
    color: #000;
    width: 100%;
    button {
      width: 100%;
    }
  }
  li {
    font-size: 2.5rem;
    font-weight: 500;
    text-transform: capitalize;
    color: #0B0A1A;
    margin-bottom: 3vh;
    padding-left: 0;
    cursor: pointer;
    justify-content: center;
    padding-right: 0;
 
    //&.disabled {
    //  opacity: 0.3;
    //  cursor: default;
    //}
    
    button {
      width: 100%;
      background-color: #195afe;
      &:hover {
        background-color: #195afe;
      }
      a {
        color: #fff;
        font-size: 2rem;
      }
    }
  }
  button {
    display: flex !important;
  }
`;

export const MobileMenuContainer = styled(Stack)`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
`;

export const MobileMenuHead = styled(FlexSpaceBetween)`
  width: 90%;
  height: fit-content;
  margin: 2.5rem auto;
  > button > svg {
    font-size: 4rem;
    transform: translateX(20px);
    path {
      fill: #0B0A1A;
    }
  }
`;
